export default __webpack_public_path__ + "static/media/memories.99f10dd7.svg";